import React from 'react';
import { Link } from 'react-router-dom';
import './CSS/PoliticaPrivacidad.css';

const PoliticaPrivacidad = () => {
  return (
    <div className="legal-page-container">
      <div className="legal-page-content">
        <h1>Política de Privacidad</h1>

        <section className="legal-section">
          <p>
            EL TITULAR se compromete a proteger la privacidad de los usuarios que accedan a esta web y/o cualquiera de sus servicios. La utilización de la web y/o de cualquiera de los servicios ofrecidos por EL TITULAR implica la aceptación por el usuario de las disposiciones contenidas en la presente Política de Privacidad y que sus datos personales sean tratados según se estipula en ella.
          </p>
          <p>
            Por favor, tenga en cuenta que a pesar de que pueda haber enlaces de nuestra web a otras webs o redes sociales, esta Política de Privacidad no se aplica a las webs de otras compañías u organizaciones a las que la web esté redirigida. EL TITULAR no controla el contenido de las webs de terceros, ni acepta cualquier responsabilidad por el contenido o las políticas de privacidad de estas webs.
          </p>
        </section>

        <section className="legal-section">
          <h2>Información básica sobre el tratamiento de datos</h2>
          <p className="legal-subtitle">(Reglamento (UE) 2016/679 y LO 3/2018)</p>

          <div className="legal-info-box">
            <div className="legal-info-item">
              <strong>Responsable del tratamiento:</strong> EL TITULAR. Nuestros datos figuran en el aviso legal de esta web.
            </div>
            <div className="legal-info-item">
              <strong>Finalidad del tratamiento:</strong> Ofrecer y gestionar nuestros productos y/o servicios.
            </div>
            <div className="legal-info-item">
              <strong>Legitimación:</strong> Consentimiento obtenido del interesado. Ejecución del contrato de servicios.
            </div>
            <div className="legal-info-item">
              <strong>Destinatarios:</strong> Los datos no serán comunicados a terceros, salvo que lo exija una Ley o sea necesario para cumplir con la finalidad del tratamiento.
            </div>
            <div className="legal-info-item">
              <strong>Derechos de las personas:</strong> Los interesados tienen derecho a ejercer los derechos de acceso, rectificación, limitación de tratamiento, supresión, portabilidad y oposición, enviando su solicitud a nuestra dirección.
            </div>
            <div className="legal-info-item">
              <strong>Plazo de conservación de los datos:</strong> Mientras se mantenga la relación comercial o durante los años necesarios para cumplir con las obligaciones legales.
            </div>
            <div className="legal-info-item">
              <strong>Reclamación:</strong> Los interesados pueden dirigirse a la AEPD para presentar la reclamación que considere oportuna.
            </div>
            <div className="legal-info-item">
              <strong>Información adicional:</strong> Puede consultar la información adicional y detallada a continuación en las "Preguntas sobre privacidad".
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Preguntas sobre privacidad</h2>
          <p>
            En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, (RGPD), y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le ofrecemos la siguiente información sobre el tratamiento de sus datos personales:
          </p>
        </section>

        <section className="legal-section">
          <h3>¿Quién es el responsable del tratamiento de sus datos?</h3>
          <p>EL TITULAR. Nuestros datos figuran en el aviso legal de esta web.</p>
        </section>

        <section className="legal-section">
          <h3>¿Con qué finalidad tratamos sus datos personales?</h3>
          <p>Tratamos la información que se nos facilita para prestar y facturar nuestros servicios y productos.</p>
          <p>Si nos da su consentimiento también podremos tratar sus datos para enviarle información sobre nuestras actividades, servicios y productos.</p>
          <p>Si participa en alguno de nuestros sorteos y/o concursos publicaremos su nombre y apellidos, y su imagen, en los diferentes espacios y medios de comunicación y difusión que utilizamos, incluidas las redes sociales, con el fin de promocionar nuestras actividades, servicios y productos.</p>
        </section>

        <section className="legal-section">
          <h3>¿Cuánto tiempo conservaremos sus datos?</h3>
          <p>Los datos personales proporcionados se conservarán mientras sea usuario de nuestros servicios o quiera recibir información, y si participa en una promoción mientras esté activa, y luego, durante los plazos establecidos para cumplir con nuestras obligaciones legales.</p>
        </section>

        <section className="legal-section">
          <h3>¿Cuál es la legitimación para el tratamiento de sus datos?</h3>
          <p>La base legal para los tratamientos de sus datos son los consentimientos que nos da.</p>
          <p>Respecto a la información que nos sea enviada por menores de 14 años, se entenderá que lo ha sido con el consentimiento de sus representantes legales. Si no es así, el representante legal del menor nos lo tiene que comunicar tan pronto como tenga conocimiento.</p>
        </section>

        <section className="legal-section">
          <h3>¿A qué destinatarios se comunicarán sus datos?</h3>
          <p>Los datos no serán comunicados a terceros, salvo que lo exija una Ley o sea necesario para cumplir con la finalidad del tratamiento.</p>
        </section>

        <section className="legal-section">
          <h3>¿Cuáles son sus derechos cuando nos facilita sus datos?</h3>
          <p>Cualquier persona tiene derecho a obtener confirmación sobre si estamos tratando o no sus datos personales.</p>
          <p>Los interesados tienen derecho a acceder a sus datos personales, así como a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para las finalidades para las que se recogieron.</p>
          <p>En determinadas circunstancias los interesados podrán solicitar la limitación del tratamiento de sus datos, en este caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.</p>
          <p>También, en determinadas circunstancias y por motivos relacionados con su situación particular, los interesados pueden oponerse al tratamiento de sus datos.</p>
          <p>Los interesados también tienen derecho a la portabilidad de sus datos.</p>
          <p>Finalmente, los interesados tienen derecho a presentar una reclamación ante la Autoridad de Control competente.</p>
        </section>

        <section className="legal-section">
          <h3>¿Cómo puede ejercer sus derechos?</h3>
          <p>Enviándonos un escrito adjuntando una copia de un documento que lo identifique, a nuestra dirección física o a la electrónica, que figuran en el aviso legal de este web.</p>
        </section>

        <section className="legal-section">
          <h3>¿Cómo hemos obtenido sus datos?</h3>
          <p>Los datos personales que tratamos proceden del propio interesado. El interesado garantiza que los datos personales facilitados son ciertos y se hace responsable de comunicar cualquier modificación de estos. Los datos que estén marcados con un asterisco serán obligatorios para poder darle el servicio solicitado.</p>
        </section>

        <section className="legal-section">
          <h3>¿Qué datos tratamos?</h3>
          <p>Las categorías de datos que podemos tratar en la prestación de nuestros servicios son:</p>
          <ul className="legal-list">
            <li>Datos de carácter identificativo</li>
            <li>Direcciones postales o electrónicas</li>
            <li>Otros datos solicitados en nuestros formularios</li>
          </ul>
          <p>Los datos son limitados, dado que únicamente tratamos los datos necesarios para la prestación de nuestros servicios y la gestión de nuestra actividad.</p>
        </section>

        <section className="legal-section">
          <h3>¿Usamos cookies?</h3>
          <p>Utilizamos cookies durante la navegación en nuestra web con el consentimiento informado del usuario. El usuario puede configurar su navegador para ser avisado de la utilización de cookies y para evitar su uso. Para obtener más información visite nuestra <Link to="/politica-cookies" className="legal-inline-link">política de cookies</Link>.</p>
        </section>

        <section className="legal-section">
          <h3>¿Qué medidas de seguridad aplicamos?</h3>
          <p>Aplicamos las medidas de seguridad establecidas en el artículo 32 del RGPD, por tanto, hemos adoptado las medidas de seguridad necesarias para garantizar un nivel de seguridad adecuado al riesgo del tratamiento de datos que realizamos, con mecanismos que nos permiten garantizar la confidencialidad, integridad, disponibilidad y resiliencia permanente de los sistemas y servicios de tratamiento.</p>
          <p>Algunas de estas medidas son:</p>
          <ul className="legal-list">
            <li>Información de las políticas de tratamiento de datos al personal</li>
            <li>Realización de copias de seguridad periódicas</li>
            <li>Control de acceso a los datos</li>
            <li>Procesos de verificación, evaluación y valoración regulares</li>
          </ul>
        </section>

        <div className="legal-back-link">
          <Link to="/">Volver al Inicio</Link>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
